export const drawerState = state => state.drawerState;

export const deliveryZipcode = state => state.deliveryZipcode;
export const redirectAfterAuthUrl = state => state.authRedirect;
export const authBehavior = state => state.authBehavior;

// Authentication
export const isAuthenticated = state => !!state.auth.token || !!localStorage.getItem('access_token');
export const personalDetails = state => state.auth?.user;
export const authToken = state => state.auth.token;
export const roles = state => state.auth?.user?.roles;

// Menu
export const menu = state => state.menu.menu;
export const selectedMenu = state => state.menu.selectedMenu;
export const menuCreated = state => state.menu.created;
export const isMenuLoaded = state => state.menu.loaded;
export const menuTouched = state => state.menu.touched;
export const menuValid = state => !state.selectedMenu?.find(ct => ct.items.length === 0);
export const menuErrors = state => state.menu.errors;

export const selectedMenuAttendee = state => state.selectedMenu;

// Categories
export const categories = state => state.orderCategories.categories;
export const currentCategory = state => state.orderCategories.current;
export const orderCategoriesLoaded = state => state.orderCategories.loaded;
export const isOrderCategoryOpen = state => !!state.orderCategories.current;
export const isOrderCategoryEdit = state => state.orderCategories.edit;
export const isAllSelected = state => state.orderCategories.allSelected;

// LineItems
export const lineItems = state => state.orderlineItems.lineItems;
export const currentLineItem = state => state.orderlineItems.current;
export const orderlineItemsLoaded = state => state.orderlineItems.loaded;
export const isOrderLineItemOpen = state => !!state.orderlineItems.current;
export const isOrderLineItemEdit = state => state.orderlineItems.edit;
export const isAllLineItemsSelected = state => state.orderlineItems.allSelected;

// Order
export const currentStep = state => state.currentStep;
export const lastStepFinished = (state, getters) => {
  let lastStep = getters.currentStep;

  if (getters.orderAttendeesCreated) {
    lastStep = 4
  } else if (getters.orderAttendeesTouched && getters.currentStep !== 4) {
    lastStep = 3
  } else if (getters.orderAttendeesTouched) {
    lastStep = 4;
  } else if (getters.orderCharacters.length) {
    lastStep = 3;
  } else if (getters.orderMessages.length) {
    lastStep = 2;
  } else if (getters.menuCreated) {
    lastStep = 1;
  }

  return lastStep;
}

export const shouldContinueAfterAuth = (state) => {
  return state.order.continueAfterAuth;
}
export const orderAttendeesCreated = (state) => {
  return state.orderAttendees.created;
}

export const isCurrentStepComplete = (state, getters) => {
  switch (getters.currentStep) {
    case 0:
      return !!getters.currentOrderId;
    case 1:
      return getters.menuCreated;
    case 2:
    case 3:
    case 5:
      return true;
    case 4:
      return getters.orderAttendeesCreated
  }
}

export const isCurrentStepTouched = (state, getters) => {
  switch (getters.currentStep) {
    case 0:
      return getters.orderDetailsTouched;
    case 1:
      return getters.menuTouched;
    case 4:
      return getters.orderAttendeesTouched
    default:
      return false;
  }
}

export const currentOrderId = state => state.order.current?.id;
export const currentOrder = state => state.order.current;
export const shouldRestoreCurrentOrder = state => state.order.shouldRestore;
export const isOrderCreated = state => !!state.order.current?.id;

export const shouldCreateNewOrder = state => !!state.order.current?.id;
export const clientSecret = state => state.order.clientSecret;
export const orderErrors = state => state.order.errors;

export const orderDetails = state => state.orderDetails.details;
export const orderDetailsValid = state => state.orderDetails.valid;
export const orderDetailsTouched = state => state.orderDetails.touched;
export const orderDetailsErrors = state => state.orderDetails.errors;

export const orderMenu = state => state.order.menu;
export const orderComplete = state => state.order.complete;

export const areOrderDetailsEdited = state => state.order.detailsEdited;
export const isOrderMenuEdited = state => state.order.menuEdited;

export const canSaveCurrentStep = (state, getters) => {
  switch (state.currentStep) {
    case 0:
      return getters.orderDetailsValid
    case 1:
      return getters.menuValid
    case 2:
    case 3:
      return true;
    case 4:
      return state.orderAttendees.touched && state.orderAttendees.valid
    case 5:
      return true;
  }
}

export const manualSelectedItemsQuantityGroupedByCategory = state => {
  const categories = {};
  if(!state.manualSelectedItemsQuantity) {
    return [];
  }
  
  state.manualSelectedItemsQuantity.forEach(item => {
    if(typeof categories[item.category] == 'undefined'){
      categories[item.category] = {
        category_id: item.category,
        items: [],
        type: 'buildabox'
      }
    }

    categories[item.category].items.push({
      id: item.id,
      quantity: item.quantity
    })
  })
  
  return categories;
}

// Order messages
export const orderMessages = state => state.orderMessages.list.sort((m1, m2) => {
  return new Date(m1.sendAt).getTime() - new Date(m2.sendAt).getTime()
});
export const messagesInOriginalOrder = state => state.orderMessages.list;
export const areOrderMessagesLoaded = state => state.orderMessages.loaded;
export const orderMessagesCreated = state => state.orderMessages.created;
export const getOrderMessagesTrigger = state => state.orderMessages.trigger;

// Message builder
export const messageBuilder = state => state.messageBuilder;
export const isMessageBuilderOpen = state => state.messageBuilder.open;
export const isMessageBuilderEdit = state => state.messageBuilder.edit;

// Order Characters
export const orderCharacters = state => state.orderCharacters.list;
export const currentCharacter = state => state.orderCharacters.current;
export const orderCharactersLoaded = state => state.orderCharacters.loaded;
export const selectedOrderCharacters = state => state.orderCharacters.selected;
export const isOrderCharacterOpen = state => !!state.orderCharacters.current;
export const isOrderCharacterEdit = state => state.orderCharacters.edit;

// Order Attendees
export const orderAttendees = state => state.orderAttendees.list;
export const orderAttendeesCount = state => state.orderAttendees.list.length;
export const areOrderAttendeesLoaded = state => state.orderAttendees.loaded;
export const canEditAttendees = state => !state.orderAttendees.complete;
export const areAttendeesComplete = state => state.orderAttendees.complete;
export const isCSVUploaded = state => state.orderAttendees.CSVuploaded;
export const areOrderAttendeesEdited = state => state.orderAttendees.edited;
export const orderAttendeesErrors = state => state.orderAttendees.errors;
export const orderAttendeesTouched = state => state.orderAttendees.touched;
export const attendeeOrderCharacters = state => state.attendeeOrderCharacters;

// Default Characters
export const defaultCharacters = state => state.defaultCharacters.list;
export const defaultCharactersLoaded = state => state.defaultCharacters.loaded;
export const isNewOrder = state => state.isNewOrder;
export const areOrderCharactersEdited = state => state.orderCharacters.edited;

// Attendee
export const isAttendeeAuthenticated = state => !!state.attendeeAuth.token || !!localStorage.getItem('attendee_access_token')
export const attendee = state => state.auth.user

export const selectedCharacter = state => state.selectedCharacter;

export const deliveryAddress = state => state.deliveryAddress;
export const isTokenTemporary = state => state.attendeeAuth.isTemporary

export const areOrderCharactersLoaded = state => state.orderCharacters.loaded;
export const currentCharacterAttendee = state => state.subOrder.character

export const currentSubOrder = state => state.subOrder.current;
export const attendeeCharacter = state => state.subOrder.character;
export const subOrderEventDetails = state => state.subOrder.event;

export const globalError = state => state.error;
export const globalSuccess = state => state.success;
export const isModalActive = state => state.isModalActive;



// Caterer
export const getCatererDetails = state => state.catererDetails;

// Event planner
export const eventPlannerDetails = state => state.eventPlannerDetails;


// Segmentations
export const segmentationOrder = state => state.segmentationOrder;
export const segmentationQuestions = state => state.segmentationQuestions;
